import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";

import {
  CREATE_ITEM_VENDOR_MUTATION,
  UPDATE_ITEM_VENDOR_MUTATION,
  DELETE_ITEM_VENDOR_MUTATION
} from "../../graphql/Vendors/ItemVendors.graphql";
import { ourToast as toast } from "../../utils";
import { ModalContext } from "../ModalProvider";

import ItemVendorForm from "./ItemVendorForm";
import Loading from "../Loading";
import { Confirmation } from "../modals";

const DEFAULT_STATE = {
  IsPrimary: false
};

const AddItemVendor = ({ onComplete, ItemRecIdRef, ItemVendor }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const { setModalOpen } = useContext(ModalContext);

  useEffect(() => {
    if (ItemVendor && ItemVendor.RecId) {
      setInputs({
        IsPrimary: ItemVendor.IsPrimary,
        ItemRecIdRef,
        VendorItemNo: ItemVendor.VendorItemNo,
        VendorRecIdRef: {
          name: "VendorRecIdRef",
          value: ItemVendor.Vendor.RecId,
          label: `${ItemVendor.Vendor.VendorNo} - ${ItemVendor.Vendor.Name}`
        }
      });
    }
  }, [ItemRecIdRef, ItemVendor]);

  const handleChange = e => {
    const updates = { ...inputs };
    if (e.value && !e.target) {
      updates[e.name] = e;
      if (e.name === "VendorRecIdRef") {
        updates.VendorRecIdRef = {
          ...e,
          label: e.otherLabel
        };
      }
    } else {
      const value =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };
  console.log(inputs);

  const [createItemVendor, { loading }] = useMutation(
    CREATE_ITEM_VENDOR_MUTATION,
    {
      refetchQueries: ["ALL_ITEM_VENDORS_QUERY"]
    }
  );

  const [updateItemVendor, res] = useMutation(UPDATE_ITEM_VENDOR_MUTATION, {
    refetchQueries: ["ALL_ITEM_VENDORS_QUERY"]
  });

  const [deleteItemVendor, resDel] = useMutation(DELETE_ITEM_VENDOR_MUTATION, {
    refetchQueries: ["ALL_ITEM_VENDORS_QUERY"]
  });

  const handleSave = async e => {
    e.preventDefault();
    try {
      if (ItemVendor) {
        await updateItemVendor({
          variables: {
            where: {
              RecId: ItemVendor.RecId
            },
            data: {
              ...inputs,
              ItemRecIdRef,
              VendorRecIdRef: inputs.VendorRecIdRef.value
                ? inputs.VendorRecIdRef.value
                : inputs.VendorRecIdRef
            }
          }
        });
        toast.success("Item Vendor updated successfully.");
      } else {
        await createItemVendor({
          variables: {
            data: {
              ...inputs,
              ItemRecIdRef,
              VendorRecIdRef: inputs.VendorRecIdRef.value
                ? inputs.VendorRecIdRef.value
                : inputs.VendorRecIdRef
            }
          }
        });
        toast.success("Item Vendor created successfully.");
      }
      onComplete();
    } catch (err) {
      toast.error("Error creating Item Vendor.");
    }
  };

  const handleDelete = async e => {
    e.preventDefault();
    const performDelete = async () => {
      setModalOpen(false, "");
      await deleteItemVendor({
        variables: {
          where: {
            RecId: parseInt(ItemVendor.RecId)
          }
        }
      });
      toast.success("Item Vendor deleted successfully.");
      onComplete();
    };
    setModalOpen(
      true,
      <Confirmation
        message="Are you sure you want to delete?"
        onConfirm={performDelete}
      />
    );
  };

  return (
    <form className="inspection-modal-container" id="add-item-vendor-form">
      {(loading || res.loading || resDel.loading) && <Loading />}
      <Title>{ItemVendor ? "Edit" : "Create"} Item Vendor</Title>
      <Fieldset disabled={loading || res.loading || resDel.loading}>
        <ItemVendorForm
          disabled={loading || res.loading || resDel.loading}
          inputs={inputs}
          onChange={handleChange}
        />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="success" form="add-vendor-form" onClick={handleSave}>
              Save
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
          {ItemVendor?.RecId && (
            <Control>
              <Button color="danger" onClick={handleDelete}>
                Delete
              </Button>
            </Control>
          )}
        </Field>
      </Fieldset>
    </form>
  );
};

AddItemVendor.propTypes = {
  onComplete: PropTypes.func,
  ItemRecIdRef: PropTypes.number,
  ItemVendor: PropTypes.object
};
export default AddItemVendor;
